import { css } from '@/styled-system/css';

export const addressDisplay = css({
  fontSize: 'body',
  color: 'text.neutral',
  fontWeight: 'bold',
});

export const mapContainer = css({
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- fixed spoke map viewport height
  height: '300px',
  borderRadius: 'md',
  overflow: 'hidden',
  backgroundColor: 'bg.softest',
  position: 'relative',
});

export const mapPlaceholder = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'tighter',
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- fixed spoke map viewport height
  height: '300px',
  borderRadius: 'md',
  background: 'bg.softest',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
});

export const sectionContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const inlineDetailBody = css({
  paddingInline: 0,
  paddingBlock: 0,
  gap: 'default',
});

export const commuteSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const commuteLabel = css({
  display: 'block',
  marginBottom: 'tighter',
});
